export default [
    {
        path:'estado-visita',
        name: 'orders-status',
        redirect: { name: "orders-status-list" },
        children: [
            {
                path:'',
                name:'orders-status-list',
                component: () => import("@/modules/orders-status/views/OrdersStatusView.vue"),
            }
        ]
    }
];
